import { FC, useEffect } from "react";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import { Input, Button } from "../../common";
import { FormErrorMessage } from "../../messages";
import { ROUTES } from "../../../routes";
import { useResendActivationMutation } from "../../../store/services/auth";

type Inputs = {
  email: string;
};

export const ResendActivationForm: FC = () => {
  const navigate = useNavigate();

  const [resendActivation, { isSuccess, isLoading, isError, error }] =
    useResendActivationMutation();

  const {
    handleSubmit,
    control,
    formState: { isDirty, isValid },
  } = useForm<Inputs>({
    defaultValues: {
      email: "",
    },
  });

  useEffect(() => {
    if (isSuccess) {
      navigate(ROUTES.AUTH_CONFIRM);
    }
  }, [isSuccess, isLoading, navigate]);

  const onSubmit: SubmitHandler<Inputs> = async (data) =>
    await resendActivation(data);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="mt-16">
      <Controller
        name="email"
        control={control}
        rules={{
          required: true,
          pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
            message: "invalid email address",
          },
        }}
        render={({ field }) => (
          <Input
            type="email"
            className="mb-8"
            placeholder="Email"
            autoFocus
            {...field}
          />
        )}
      />

      <FormErrorMessage className="mb-8" isError={isError} error={error} />

      <Button
        type="submit"
        variant={Button.variant.PRIMARY}
        className="w-full"
        disabled={!isDirty || !isValid}
      >
        Get New Link
      </Button>
    </form>
  );
};
